import { defineComponent, h, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '../../state';
import { show_search_modal } from '../../non_graphical_ui_actions';
import BarButton from '@components/bar-button';
import search_svg from '../../../assets/img/SVG_icons/Top/search/search.svg';
import { img } from '@phi/components';
import SearchTooltip from './SearchTooltip';

export default defineComponent({
    props: {
        state: { required: true, type: Object as PropType<State> },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Search';
        },

        disabled() {
            if (this.state.is_demo)
                return false;
            else return !this.state.loaded;
        },
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            else
                show_search_modal();
        },
    },

    render() {
        return h(BarButton, {
            id: 'search-button',
            wrapperId: 'search-wrapper',
            onClick: this.onClick,
            selected: this.state.tut_stage === 14,
            active: false,
            disabled: this.disabled,
            tippy: 'left',
        }, {
            label: () => 'Search',
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(search_svg, this.alt),
            tooltip: SearchTooltip,
        });
    }
});
